/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PluginType = {
    _11184809: '11184809',
    TICKET_SCAN: 'TICKET_SCAN',
    REWARD_ASSIGNMENT: 'REWARD_ASSIGNMENT',
    PLAYER_AUTH: 'PLAYER_AUTH',
    PLAYER_DETAILS: 'PLAYER_DETAILS',
    PLAYER_ELIGIBILITY: 'PLAYER_ELIGIBILITY',
    PLAYER_POINTS: 'PLAYER_POINTS',
    REWARD_CATALOG: 'REWARD_CATALOG',
    TICKET_SCAN_DISPLAY: 'TICKET_SCAN_DISPLAY',
    unknown_default_open_api: '11184809'
} as const;
export type PluginType = typeof PluginType[keyof typeof PluginType];


export function instanceOfPluginType(value: any): boolean {
    for (const key in PluginType) {
        if (Object.prototype.hasOwnProperty.call(PluginType, key)) {
            if (PluginType[key as keyof typeof PluginType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PluginTypeFromJSON(json: any): PluginType {
    return PluginTypeFromJSONTyped(json, false);
}

export function PluginTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PluginType {
    return json as PluginType;
}

export function PluginTypeToJSON(value?: PluginType | null): any {
    return value as any;
}

